class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.section = this.closest('.home-row');
    this.previous = this.section?.querySelector('[data-carousel-prev]');
    this.next = this.section?.querySelector('[data-carousel-next]');
    if (!this.track || !this.previous || !this.next) return;

    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.paint(), { passive: true });
    new ResizeObserver(() => this.paint()).observe(this.track);
    this.paint();
  }

  move(direction) {
    const card = this.track.firstElementChild;
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  paint() {
    const end = this.track.scrollWidth - this.track.clientWidth;
    this.previous.disabled = this.track.scrollLeft <= 1;
    this.next.disabled = this.track.scrollLeft >= end - 1;
  }
}

customElements.define('product-carousel', ProductCarousel);
